/**
 * Component to filter test lists
 */
import * as React from 'react';
import { Card, Row, Col, Input, Checkbox, Radio, DatePicker } from 'antd';
import '../../css/TestFilter.scss';
import Constants from '../common/constants';
import moment from 'moment';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
import strings from '../../eyeguide-localization/test/string.test.filter';
import Token from '../common/token';

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const {  RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';

interface ITestProps {
    notifyChangeFilter: any; 
    form: any;
    showOrg: boolean;
    showNotifs: boolean;
    isOpen: boolean;
    // organization: any;
    filterObj: any;
}
    
interface ITestState {
    sportsArr: any;
    isOpen: boolean;
    filterObj: any;
    showHealthData: any;
}

export default class TestFilter extends React.Component<ITestProps, ITestState> {
    name:     any ;
    dateFrom:       React.RefObject<Input> ;
    dateTo:             React.RefObject<Input> ;
    testType:         any ;
    metaInfoMap: any;
    filterObj: any;

    constructor(props: ITestProps) {
        super(props); 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.name = '';
        this.dateFrom = React.createRef();
        this.dateTo = React.createRef();
        this.testType = '';
        this.state = {
            sportsArr: [],
            isOpen: false,
            filterObj: {
                'name' : '',
                'testType': [],
                'organization': [],
                'baseline': '-1',
                'concussed': ''
            },
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData)
        };

        this.filterObj = this.initializeFilter();
        console.log(this.filterObj.firstname);
    }

    componentDidMount() {
        this.resetControls();
        this.setState({
            filterObj: this.props.filterObj
        });
        setTimeout(() => {this.name.focus() ; }, 1);
        console.log('filterdate', this.state.filterObj.startDate);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            isOpen: nextProps.isOpen,
            filterObj: nextProps.filterObj
        });
        if (nextProps.isOpen) {
            this.resetControls();
        }
        setTimeout(() => {this.name.focus() ; }, 1);

    }

    render() {
        console.log('startdate', this.state.filterObj.startDate);
        if (this.state.isOpen) {
            this.resetControls();
            this.setState({
                isOpen: false
            });
        }
        let testTypes = Constants.getTestTypes();

        return(
        <div className="TestFilter">
        <Card className="filterCard" bordered={false} style={{ margin: '24px 16px' }} >
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={4} xl={4} className="labelFrame">
                <div className="label">
                    <span> {strings.lsAthleteTxt}
                    :</span>
                </div>
            </Col> 
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                <Input 
                    ref={val => this.name = val}
                    defaultValue=""
                    placeholder="e.g. Johnny" 
                    onChange={(val) => {this.handleChange(val.target.value, 'name'); }}
                    value={this.state.filterObj.name}
                />
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
        </Row>
        <Row className="row">
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={4} xl={4} className="labelFrame">
                <div className="label">
                    <span>  {strings.lsStartEndDateTxt}
                    :</span>
                </div>
            </Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                <RangePicker 
                        onChange={(date: any, dateString: any) => {
                            console.log('datestring', dateString.toString()); 
                            if (dateString.toString().split(',').length >= 2 
                                && dateString.toString() !== ',' ) {
                                this.handleChange(dateString.toString().split(',')[1], 'endDate');
                                this.handleChange(dateString.toString().split(',')[0], 'startDate'); 
                            } else {
                                this.handleChange(undefined, 'endDate');
                                this.handleChange(undefined, 'startDate'); 
                            }
                            }
                        }
                        format={dateFormat} 
                        value={  this.state.filterObj.startDate !== undefined &&
                                this.state.filterObj.endDate !== undefined ?
                                [moment(this.state.filterObj.startDate), moment(this.state.filterObj.endDate)] 
                             : []
                            }
                />
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        {this.state.showHealthData ? 
        <Row className="row" hidden={this.props.showOrg}>
            <Col xs={1} sm={1} md={2} lg={5} xl={5} />
            <Col xs={8} sm={8} md={5} lg={4} xl={4} className="labelFrame">
            <div className="label">{strings.lsTestTypeTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <CheckboxGroup 
                className="labelFrame"
                style={{ width: '100%' }} 
                onChange={(val) => {console.log('val of testType', val);
                                    this.handleChange(val, 'testType'); }}
                value={this.state.filterObj.testType}
            >
                <Row>
                    {testTypes.map(x => <Col key={x} span={12}>
                    <Checkbox 
                        value={x} 
                        key={x}     
                    >
                    {x}                  
                    </Checkbox></Col>)}
                </Row>
            </CheckboxGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        : ''}
        <Row className="row">
            <Col xs={1} sm={1} md={1} lg={5} xl={5} />
            <Col xs={8} sm={8} md={6} lg={4} xl={4} className="labelFrame">
            <div className="label">{strings.lsBaselineTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <RadioGroup 
                className="labelFrame" 
                value={this.state.filterObj.baseline}
                onChange={(val) => this.handleChange(val.target.value, 'baseline')}
            >
                <Radio defaultChecked={false} value={0}>{Constants.getConcussionFilterValue()[0]}</Radio>
                <Radio defaultChecked={false} value={1}>{Constants.getConcussionFilterValue()[1]}</Radio>
                <Radio defaultChecked={false} value={2}>{Constants.getConcussionFilterValue()[2]}</Radio>
            </RadioGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        {/* {this.state.showHealthData ? 
        <Row className="row">
            <Col xs={1} sm={1} md={1} lg={5} xl={5} />
            <Col xs={8} sm={8} md={6} lg={4} xl={4} className="labelFrame">
            <div className="label">{strings.lsConussionTxt} :</div></Col>
            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
            <RadioGroup 
                className="labelFrame" 
                value={this.state.filterObj.concussed}
                onChange={(val) => this.handleChange(val.target.value, 'concussed')}
            >
                <Radio defaultChecked={false} value={0}>{Constants.getConcussionFilterValue()[0]}</Radio>
                <Radio defaultChecked={false} value={1}>{Constants.getConcussionFilterValue()[1]}</Radio>
                <Radio defaultChecked={false} value={2}>{Constants.getConcussionFilterValue()[2]}</Radio>
            </RadioGroup>
            </Col>
            <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
        </Row>
        : ''} */}
    </Card>
    </div>
        );
    }

    private handleChange(e: any, prop: string) {
        console.log('handleChange', e);
        // this.filterObj[prop] = e;
        // console.log('this.filterObj', this.filterObj);
        if (!(e === undefined) && !(e instanceof Array) && e.toString().trim().length === 0) {
            e = '';
        }
        let filterObj = this.state.filterObj;
        filterObj[prop] = e;
        this.setState({
            filterObj: filterObj
        });
        this.props.notifyChangeFilter(this.state.filterObj);
    }

    private initializeFilter(): Array<any> {
        let filterObj: any = [];
        filterObj = {
            'name' : '',
            'endDate'  : '',
            'startDate' : '',
            'testType': [],
            'organization': [],
            'baseline': '-1',
            'concussed': ''
        };
        return filterObj;
    }

    /**
     * Reset all control values
     */
    private resetControls() {
        this.name = '';
        this.dateFrom = React.createRef();
        this.dateTo = React.createRef();
         // this.level = '';
        this.testType = React.createRef();
       
    }

}


// WEBPACK FOOTER //
// ./src/components/test/TestFilter.tsx